import { Component, input, model, output } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { Drawer } from 'primeng/drawer'
import { Select } from 'primeng/select'

import { ButtonComponent } from 'app/_shared/components/button/button.component'
import { OrderStatus, SortOption } from 'app/pages/account/orders/utils/orders.utils'

@Component({
  selector: 'app-mobile-orders-filters',
  standalone: true,
  imports: [Select, FormsModule, ButtonComponent, Drawer],
  templateUrl: './mobile-orders-filters.component.html',
  styleUrl: './mobile-orders-filters.component.scss'
})
export class MobileOrdersFiltersComponent {
  // Inputs
  sortOptions = input.required<SortOption[]>()
  statusOptions = input.required<{ label: string; value: OrderStatus }[]>()

  // Two-way bindings
  visible = model.required<boolean>()
  selectedStatus = model<OrderStatus>()
  selectedSortOption = model<SortOption['value']>()

  // Outputs
  applyFilters = output<void>()
  clearFilters = output<void>()

  onFiltersChanged() {
    // Track changes but don't apply until user clicks "See Results"
  }

  onApplyFilters() {
    this.visible.set(false)
    this.applyFilters.emit()
  }

  onClearFilters() {
    this.selectedStatus.set(undefined)
    this.selectedSortOption.set(undefined)
    this.clearFilters.emit()
  }
}
